<template>
    <div>
       
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        name: 'FacturaRapidaItems',
        props: ['item', 'action'],
        data: () => {
            return {
                preitem: {},
                items: []
            }
        },
        mounted() {
            this.initPreItem()
        },
        watch: {
            'action.i': function () {
                if(this.action.i){
                    for( let i = 0; i<this.item.length; i++){ 
                        this.completeItem(i)
                    }
                }   
            },
            'action.reset': function () {
                if(this.action.reset){
                    this.items = []
                }   
            }
        },
        methods: {
            initPreItem: function () {
                this.preitem = {
                    idFacturaItem:"",
                    unidadMedidaCantidad:"",
                    cantidad: "",
                    idProducto: "",
                    valorVenta: "",
                    precioVentaUnitario:"",
                    tipoPrecioVentaUnitario:"",
                    montoTotalImpuestosItem:"",
                    baseAfectacionIgv: "",
                    montoAfectacionIgv: "",
                    porcentajeImpuesto: "",
                    tipoAfectacionIgv: "",
                    codigoTributo: "",
                    descripcion: "",
                    valorUnitario:"",
                    codigoProducto: "",
                    codigoProductoSunat:"",
                    codigoProductoGs1: "",
                    descuento: "",
                    porcentajeDescuento: "",
                    afectoIcbper: "",
                    iscOtrosTributosItem: "",
                    cargosDescuentosItem: "",
                    adicional: "",
                    idFactura: "",
                    
                }
            },
            convertExceltoJson: function () {
                // Funcion para la carga masiva de items
            },
            completeItem: function (i) {
                if(this.item){
                    this.preitem.idFacturaItem = parseFloat(this.item[i].idFacturaItem)
                    this.preitem.unidadMedidaCantidad = this.item[i].unidadMedidaCantidad
                    this.preitem.cantidad = parseFloat(this.item[i].cantidad)
                    this.preitem.idProducto = "-"
                    this.preitem.valorVenta = parseFloat(this.item[i].valorVenta)
                    this.preitem.precioVentaUnitario = parseFloat(this.item[i].precioVentaUnitario)
                    this.preitem.tipoPrecioVentaUnitario = this.item[i].tipoPrecioVentaUnitario
                    this.preitem.montoTotalImpuestosItem = parseFloat(this.item[i].montoTotalImpuestosItem)
                    this.preitem.baseAfectacionIgv = parseFloat(this.item[i].baseAfectacionIgv)
                    this.preitem.montoAfectacionIgv = parseFloat(this.item[i].montoAfectacionIgv)
                    this.preitem.porcentajeImpuesto = parseFloat(this.item[i].porcentajeImpuesto)
                    this.preitem.tipoAfectacionIgv =  this.item[i].tipoAfectacionIgv
                    this.preitem.codigoTributo = this.item[i].codigoTributo
                    this.preitem.descripcion = this.item[i].descripcion
                    this.preitem.valorUnitario = parseFloat(this.item[i].valorUnitario)
                    this.preitem.codigoProducto = this.item[i].codigoProducto
                    this.preitem.codigoProductoSunat = this.item[i].codigoProductoSunat
                    this.preitem.codigoProductoGs1 = this.item[i].codigoProductoGs1
                    this.preitem.descuento = parseFloat(this.item[i].descuento)
                    this.preitem.porcentajeDescuento = parseFloat(this.item[i].porcentajeDescuento)
                    this.preitem.afectoIcbper = parseFloat(this.item[i].afectoIcbper)
                    this.preitem.iscOtrosTributosItem = this.item[i].iscOtrosTributosItem
                    this.preitem.cargosDescuentosItem = this.item[i].cargosDescuentosItem
                    this.preitem.adicional = this.item[i].adicional
                    this.preitem.idFactura = parseFloat(this.item[i].idFactura)

                    this.items.unshift(this.preitem)
                    this.initPreItem()
                    this.getItems(this.items)
                }
            },
            getItems: function (data) {
                this.$emit("totalitems", data);
            }
        }  
    }
</script>

<style>